export class DashboardConstants {
    static PHASES_HEADING = "Progress status";
    static DEFAULT_COLUMN = "default";
    static MODULES_SEARCH_PLACEHOLDER_TEXT = "Filter modules";
}
